module.exports = __webpack_public_path__ + "static/media/monkey-madness.ff637aeb.gif";